export default function MicrosoftLogo({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 23 23" className={className} aria-hidden="true" focusable="false">
      <rect x="0" y="0" width="10" height="10" fill="#F25022" />
      <rect x="12" y="0" width="10" height="10" fill="#7FBA00" />
      <rect x="0" y="12" width="10" height="10" fill="#00A4EF" />
      <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
    </svg>
  )
}

/** The one logo tile size used on cards, product headers, the cart, and the quote summary */
export function MicrosoftLogoTile() {
  return (
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-primary-ink-10 bg-primary-ink-6">
      <MicrosoftLogo className="h-6 w-6" />
    </span>
  )
}

function GoogleLogo({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true" focusable="false">
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"
      />
      <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.07H2.18a11 11 0 0 0 0 9.86l3.66-2.84z" />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      />
    </svg>
  )
}

export function CartLineLogoTile({ vendor }: { vendor?: 'google-workspace' }) {
  return vendor === 'google-workspace' ? <GoogleLogoTile /> : <MicrosoftLogoTile />
}

export function GoogleLogoTile() {
  return (
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-primary-ink-10 bg-primary-ink-6">
      <GoogleLogo className="h-6 w-6" />
    </span>
  )
}
